export default {
  getAll: {
    url: '/api/product/getAll',
    method: 'get'
  },
  create: {
    url: '/api/product/create',
    method: 'post'
  },
  update: {
    url: '/api/product/update',
    method: 'put'
  },
  delete: {
    url: '/api/product/delete',
    method: 'delete'
  },
  picUpload: {
    url: '/api/product/picUpload',
    method: 'post'
  }
}



// WEBPACK FOOTER //
// ./src/api/product.js